

























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { dispatchCreateFarmRegistrationLink, dispatchSendFarmRegistrationEmail } from '@/store/farm/actions';

@Component
export default class FarmRequestRegistrationDialog extends Vue {
    public requestRegistrationDialog: boolean = false;

    public userEmail: string = '';

    // Properties for the Registration Request Email.
    public registrationEmailLoading: boolean = false;
    public registrationEmailSent: boolean = false;

    // Properties for the Registration Generate Link.
    public registrationLinkLoading: boolean = false;
    public registrationLinkLoaded: boolean = false;
    public registrationLink: string = '';

    public async generateRegistrationLink() {
        // Query the API to get an Registration link with an API token embedded in the query params.
        this.registrationLinkLoading = true;
        const link = await dispatchCreateFarmRegistrationLink(this.$store);
        if (link) {
            this.registrationLink = link;
            this.registrationLinkLoaded = true;
        }
        this.registrationLinkLoading = false;
    }

    public async sendRegistrationEmail() {

        this.registrationEmailLoading = true;
        await dispatchSendFarmRegistrationEmail(
          this.$store,
          {emailTo: this.userEmail},
        ).then((success) => {
            this.registrationEmailLoading = false;
            this.registrationEmailSent = true;
          }, (failure) => {
            this.registrationEmailLoading = false;
            this.registrationEmailSent = false;
          },
        );
    }

    public openDialog() {
        this.requestRegistrationDialog = true;
        this.registrationEmailSent = false;
        this.userEmail = '';
    }

    public closeDialog() {
        this.requestRegistrationDialog = false;
    }

}


